<template>
    <b-modal id="connectModal" v-model="showConnectModal" :hide-header="true" :hide-footer="true">
		<div id="modalEndo" v-if="targetConnectModal=='endo'">
			<div id="endo" v-if="!confirmEndomondo">
				<div class="endomondo-header">
					<div class="endomondo-logo"></div>
				</div>
				<div class="connectForm">
					<b-form @submit="doEndo">
						<b-form-group id="email-group"
							:label="$t('signin.form.email')"
							label-for="email">
							<b-form-input
								id="email"
								type="email"
								v-model="endomondoForm.username"
								required

							></b-form-input>
						</b-form-group>

						<b-form-group id="password-group" class="password"
							:label="$t('signin.form.pwd')"
							label-for="password">
							<b-form-input
								id="password"
								type="password"
								v-model="endomondoForm.password"
								required
							></b-form-input>
							
						</b-form-group>
						<b-form-checkbox
							id="acceptance"
							v-model="endomondoForm.rememberPass"
							name="acceptance"
							>
							<p v-html="$t('register.form.virtual.auth.remember')"></p>
						</b-form-checkbox>
						<div class="clearfix" v-if="authError">
							<!-- <pre>{{status}}</pre> -->
							<div class="errorMsg" v-html="$t('register.form.virtual.auth.error')"></div>
						</div>
						<div class="clearfix">
							<b-button :disabled="connectingTracker" block type="submit" class="btn-auth endo">
								<b-spinner v-if="connectingTracker" small></b-spinner> {{ $t("register.form.virtual.auth.login") }}
							</b-button>
						</div>
						<div class="clearfix">
							<b-button block class="btn-reset" href="https://www.endomondo.com/forgotpassword" target="_blank">{{ $t("register.form.virtual.auth.reset") }}</b-button>
						</div>
						<div class="clearfix">
							<b-button block class="btn-signup" href="https://www.endomondo.com/signup" target="_blank">{{ $t("register.form.virtual.auth.signup") }}</b-button>
						</div>
					</b-form>
				</div>
			</div>

			<div id="endoConfirm" v-if="confirmEndomondo">
				<div class="endomondo-header">
					<div class="endomondo-logo"></div>
				</div>
				<div class="accountDetails">
					<!-- <pre>{{endomondoProfile.data.data}}</pre> -->
					<img :src="endomondoProfile.data.data.avatar_url" class="avatar">
					<p class="username">{{endomondoProfile.data.data.first_name}} {{endomondoProfile.data.data.last_name}}</p>
					<p class="email">{{endomondoProfile.data.data.email}}</p>
					<b-button @click="confirmConnection('endomondo')" block type="button" class="btn-auth endo">
						{{ $t("register.form.virtual.auth.confirm") }}
					</b-button>
					<b-button @click="cancelConnection" block type="button" class="btn-reset">{{ $t("register.form.virtual.auth.change") }}</b-button>
				</div>
				<div class="clearfix" v-if="accountDuplicate">
					<div class="errorMsg" v-html="$t('register.form.virtual.auth.errorDuplicate')"></div>
				</div>
			</div>
		</div>

		<div id="modalGarmin" v-if="targetConnectModal=='garmin'">
			<div id="garmin" v-if="!confirmGarmin">
				<div class="garmin-header">
					<div class="garmin-logo"></div>
				</div>
				<div class="connectForm">
					<b-form  @submit="doGarmin">
						<b-form-group id="email-group"
							:label="$t('signin.form.email')"
							label-for="email">
							<b-form-input
								id="email"
								type="text"
								v-model="garminForm.username"
								required
							></b-form-input>
						</b-form-group>

						<b-form-group id="password-group" class="password"
							:label="$t('signin.form.pwd')"
							label-for="password">
							<b-form-input
								id="password"
								type="password"
								v-model="garminForm.password"
								required
							></b-form-input>
							
						</b-form-group>
						<b-form-checkbox
							id="acceptance"
							v-model="garminForm.rememberPass"
							name="acceptance"
							>
							<p v-html="$t('register.form.virtual.auth.remember')"></p>
						</b-form-checkbox>
						
						<div class="clearfix" v-if="authError">
							<div class="errorMsg" v-html="$t('register.form.virtual.auth.error')"></div>
						</div>
						<div class="clearfix">
							<b-button :disabled="connectingTracker" block type="submit" class="btn-auth garmin">
								<b-spinner v-if="connectingTracker" small></b-spinner>  {{ $t("register.form.virtual.auth.login") }}
							</b-button>
						</div>
					</b-form>
				</div>
			</div>

			<div id="garminConfirm" v-if="confirmGarmin">
				<!-- <pre>{{garminProfile.data.data}}</pre> -->
				<div class="garmin-header">
					<div class="garmin-logo"></div>
				</div>
				<div class="accountDetails">
					<p class="username">{{garminProfile.data.data.displayName}}</p>
					<p class="email">{{garminProfile.data.data.emailAddress}}</p>
					<b-button @click="confirmConnection('garmin')" block type="submit" class="btn-auth garmin">{{ $t("register.form.virtual.auth.confirm") }}</b-button>
					<b-button @click="cancelConnection" block type="submit" class="btn-reset" target="_blank">{{ $t("register.form.virtual.auth.change") }}</b-button>
				</div>
				<div class="clearfix" v-if="accountDuplicate">
					<div class="errorMsg" v-html="$t('register.form.virtual.auth.errorDuplicate')"></div>
				</div>
			</div>
		</div>
		
    </b-modal>
</template>
<script>
	import SvgImage from '../components/SvgImage.vue';
	export default {
		data () {
			return {
				sendMemberData : false,
				connectingTracker : false,
				confirmGarmin : undefined,
				confirmStrava : undefined,
				confirmEndomondo : undefined,
				endomondoProfile : undefined,
				authError : undefined,
				accountDuplicate : undefined,
				endomondoForm : {
					username : undefined,
					password : undefined,
					rememberPass : true,
				},
				garminForm : {
					username : undefined,
					password : undefined,
					rememberPass : true,
				}
			}
		},		
		props: {
			showConnectModal: Boolean,
			targetConnectModal: String
		},
	    components : {  
		    SvgImage,
	    },
		methods: {
			confirmConnection(app){
				const constructedData = {
					tracMemberId : this.$parent.userProfile.memberId
				};
				if (app=='endomondo'){
					constructedData.tracTrackerApp = 'endomondo';
					constructedData.tracUsername = this.endomondoForm.username;
					constructedData.tracPassword = this.endomondoForm.password;
					constructedData.tracRememberPassword = this.endomondoForm.rememberPass;
					constructedData.tracTrackerAccountId = this.endomondoProfile.data.data.id;
					constructedData.tracTrackerProfileData = JSON.stringify(this.endomondoProfile.data.data);
				}
				if (app=='garmin'){
					constructedData.tracTrackerApp = 'garmin';
					constructedData.tracUsername = this.garminForm.username;
					constructedData.tracPassword = this.garminForm.password;
					constructedData.tracRememberPassword = this.garminForm.rememberPass;
					constructedData.tracTrackerAccountId = this.garminProfile.data.data.customerId;
					constructedData.tracTrackerProfileData = JSON.stringify(this.garminProfile.data.data);
				}
				if (this.sendMemberData){
					this.$store.dispatch('ADDENDOMONDO', {data:{mappEndomondo:this.endomondoProfile.data.data.id}})
				}
				this.$store.dispatch('STOREPROFILE', {data:constructedData})
					.then(stored=>{
						if (stored.status==200){
							this.$parent.VRactivated =true;
							this.$parent.showConnectModal = false;
							this.modalShow = false;
							this.$parent.init();
						}
						// console.log(stored);
						// this.confirmEndomondo = true;
						// this.endomondoProfile = authEndoOut;
						// this.$parent.showJerseyModal = false;
						// this.$parent.showPaymentModal = true;
						// this.$store.dispatch('GETTRANSACTION', {data:this.transactionData.data.trnsRefId})
						// 	.then((transactionOut)=>{
						// 		this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
						// 		this.transactionData = transactionOut.data;
						// 		console.log('Transaction out : ', transactionOut);
						// 	})
						// 	.catch((err)=>{
						// 		console.log(err);
						// 	})
					})
					.catch(err=>{
						this.authError = true;
						// console.log('E : ', err);
						if (err.response){
							this.status = err.response;						
						}
					})
				console.log('Confirm connection...', constructedData);
			},
			cancelConnection(){
				console.log('Cancel connection...');
				// this.$parent.showConnectModal = false;
				// this.modalShow = false;
				this.endomondoProfile = undefined;
				this.confirmEndomondo = false;
				this.garminProfile = undefined;
				this.confirmGarmin = false;
			},
			doEndo(e){
				e.preventDefault();
				this.connectingTracker = true;
				// var _data = {
				// 	participantId : this.$parent.ballotDataDetail.evpaId, 
				// 	jerseyId : this.jerseySize
				// }
				console.log('Doing endo... ', this.endomondoForm);

				this.$store.dispatch('AUTHENDO', {data:this.endomondoForm})
					.then(authEndoOut=>{
						console.log(authEndoOut);
						this.connectingTracker = false;
						this.confirmEndomondo = true;
						this.endomondoProfile = authEndoOut;
						this.$parent.init();
						// this.$parent.showJerseyModal = false;
						// this.$parent.showPaymentModal = true;
						// this.$store.dispatch('GETTRANSACTION', {data:this.transactionData.data.trnsRefId})
						// 	.then((transactionOut)=>{
						// 		this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
						// 		this.transactionData = transactionOut.data;
						// 		console.log('Transaction out : ', transactionOut);
						// 	})
						// 	.catch((err)=>{
						// 		console.log(err);
						// 	})
					})
					.catch(err=>{
						this.connectingTracker = false;
						this.authError = true;
						// console.log('E : ', err);
						if (err.response){
							this.status = err.response;						
						}
					})
			},
			doGarmin(e){
				e.preventDefault();
				this.connectingTracker = true;
				// var _data = {
				// 	participantId : this.$parent.ballotDataDetail.evpaId, 
				// 	jerseyId : this.jerseySize
				// }
				console.log('Doing garmin... ', this.garminForm);
				this.$store.dispatch('AUTHGARMIN', {data:this.garminForm})
					.then(authGarminOut=>{
						console.log(authGarminOut);
						this.connectingTracker = false;
						this.confirmGarmin = true;
						this.garminProfile = authGarminOut;
						this.$parent.init();
						// this.$parent.showJerseyModal = false;
						// this.$parent.showPaymentModal = true;
						// this.$store.dispatch('GETTRANSACTION', {data:this.transactionData.data.trnsRefId})
						// 	.then((transactionOut)=>{
						// 		this.$store.commit('SET_ACTIVE_TRANSACTION', {transaction:transactionOut});
						// 		this.transactionData = transactionOut.data;
						// 		console.log('Transaction out : ', transactionOut);
						// 	})
						// 	.catch((err)=>{
						// 		console.log(err);
						// 	})
					})
					.catch(err=>{
						this.connectingTracker = false;
						this.authError = true;
						// console.log('E : ', err);
						if (err.response){
							this.status = err.response;						
						}
					})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// ConnectModal.vue